import ModelUtil from '@leverege/model-util';
import { Attributes } from '@leverege/ui-attributes';
import { differenceInHours } from 'date-fns';
const TYPE = 'symbolizer.VehicleLocatorAlerts';
const accuracyAttributes = {
  vehicle: 'vehicle.locator$locator.accuracy',
  locator: 'locator.accuracy'
};
const motionReportedAtAttributes = {
  vehicle: 'vehicle.locator$locator.events.motionReportedAt',
  locator: 'locator.events.motionReportedAt'
};
const positionReportedAtAttributes = {
  vehicle: 'vehicle.locator$locator.positionReportedAt',
  locator: 'locator.positionReportedAt'
};
const batteryLevelAttributes = {
  vehicle: 'vehicle.locator$locator.batteryLevel',
  locator: 'locator.batteryLevel'
};
const businessStateAttributes = {
  vehicle: 'vehicle.locator$locator.businessState',
  locator: 'locator.businessState'
};
const pendingSaleAttributes = {
  vehicle: 'vehicle.pendingSaleId'
};
const motionEventAttributes = {
  vehicle: 'vehicle.locator$locator.events.motion',
  locator: 'locator.events.motion'
};
const currentlyInMotionAttributes = {
  vehicle: 'vehicle.locator$locator.events.motionInfo.currentlyInMotion',
  locator: 'locator.events.motionInfo.currentlyInMotion'
};
function create() {
  return {
    type: TYPE,
    myCustomValue: null
  };
}
function symbolFor(model, obj, context) {
  const accuracyAttr = accuracyAttributes[obj.type];
  const motionReportedAtAttr = motionReportedAtAttributes[obj.type];
  const positionReportedAtAttr = positionReportedAtAttributes[obj.type];
  const batteryLevelAttr = batteryLevelAttributes[obj.type];
  const businessStateAttr = businessStateAttributes[obj.type];
  const pendingSaleAttr = pendingSaleAttributes[obj.type];
  const motionEventAttr = motionEventAttributes[obj.type];
  const currentlyInMotionAttr = currentlyInMotionAttributes[obj.type];
  const motionReportedAt = Attributes.get(motionReportedAtAttr, obj.type, obj.data) || 0;
  const positionReportedAt = Attributes.get(positionReportedAtAttr, obj.type, obj.data) || 0;
  const businessState = Attributes.get(businessStateAttr, obj.type, obj.data) || 0;
  if (businessState === 'stolen') {
    return 'activeTheftRecovery';
  }
  if (businessState === 'suspected-drive-off') {
    return 'suspectedDriveOff';
  }
  if (businessState === 'suspected-off-lot') {
    return 'suspectedOffLot';
  }
  const inMotion = Attributes.get(motionEventAttr, obj.type, obj.data);
  const currentlyInMotion = Attributes.get(currentlyInMotionAttr, obj.type, obj.data);
  if (currentlyInMotion) {
    return 'inMotion';
  }
  if (currentlyInMotion == null && motionReportedAt && inMotion) {
    return 'inMotion';
  }
  if (obj.type === 'vehicle') {
    const pendingSaleId = Attributes.get(pendingSaleAttr, obj.type, obj.data) || 0;
    if (pendingSaleId) {
      return 'pendingSale';
    }
  }
  if (obj.type === 'locator') {
    if (businessState === 'drive-off' || businessState === 'assumed-drive-off' || businessState === 'support-required' || businessState === 'lost') {
      return 'lostDriveOff';
    }
  }
  const diff = differenceInHours(Date.now(), positionReportedAt);
  if (positionReportedAt && diff > 48) {
    return 'staleLocation';
  }
  const accuracy = Attributes.get(accuracyAttr, obj.type, obj.data);
  if (accuracy && accuracy > 100) {
    return 'lowAccuracy';
  }
  const batteryLevel = Attributes.get(batteryLevelAttr, obj.type, obj.data);
  if (batteryLevel && batteryLevel < 15) {
    return 'lowBattery';
  }
  return null;
}
export default {
  TYPE,
  create,
  name: 'Vehicle/Locator Alerts',
  ...ModelUtil.createAllValue('myCustomValue'),
  symbolFor
};